import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/missing/translation.promote.mutation.gql"
import type {
  TranslationPromoteMutation,
  TranslationPromoteMutationVariables,
} from "@/v2-backoffice-client/translation/missing/__types__/translation.promote.mutation"

type Options = MutationHookOptions<
  TranslationPromoteMutation,
  TranslationPromoteMutationVariables
>

export function useTranslationPromoteMutation(options?: Options) {
  return useMutation<
    TranslationPromoteMutation,
    TranslationPromoteMutationVariables
  >(mutation, {
    // Promoted codes leave the missing list and appear in the catalog (under
    // "Missing translations" until translated), so both caches refresh. Loop
    // callers (the per-code AI mode) suppress this per call via the mutate
    // options and refetch once at the end instead.
    refetchQueries: ["TranslationMissingQuery", "TranslationCatalogQuery"],
    ...options,
  })
}
